import { CryptoPrice } from './types';

export class CryptoService {
  async fetchCryptoData(): Promise<CryptoPrice[]> {
    try {
      console.log('🪙 Fetching crypto data from proxy server...');
      
      const response = await fetch('/api/crypto-rates', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('📄 Crypto data received:', data.length, 'items');
      
      // Eğer boş gelirse mock veri kullan
      if (!data || data.length === 0) {
        console.log('🔄 Empty response, using mock data...');
        return this.getMockCryptoData();
      }
      
      // JSON verisini CryptoPrice formatına dönüştür
      const cryptos = data.map((item: any) => ({
        Symbol: item.symbol || item.Symbol || 'UNKNOWN',
        Name: item.name || item.Name || 'Bilinmeyen',
        Price: item.price || item.Price || 0,
        Change: item.change || item.Change || 0,
        ChangePercent: item.changePercent || item.ChangePercent || 0,
        Volume: item.volume || item.Volume || 'N/A'
      }));
      
      console.log(`✅ Parsed ${cryptos.length} cryptos from proxy`);
      
      return cryptos;
    } catch (error) {
      console.error('❌ Error fetching from proxy:', error);
      console.log('🔄 Falling back to mock data...');
      
      // Hata olursa mock veri döndür
      return this.getMockCryptoData();
    }
  }

  private getMockCryptoData(): CryptoPrice[] {
    return [
      { Symbol: 'BTC', Name: 'Bitcoin', Price: 3456789.50, Change: 45230.50, ChangePercent: 1.32, Volume: '1.2B' },
      { Symbol: 'ETH', Name: 'Ethereum', Price: 98765.25, Change: 1234.75, ChangePercent: 1.27, Volume: '856M' },
      { Symbol: 'BNB', Name: 'Binance Coin', Price: 12456.80, Change: -234.50, ChangePercent: -1.85, Volume: '234M' },
      { Symbol: 'USDT', Name: 'Tether', Price: 32.15, Change: 0.02, ChangePercent: 0.06, Volume: '567M' },
      { Symbol: 'XRP', Name: 'Ripple', Price: 15.85, Change: 0.45, ChangePercent: 2.93, Volume: '123M' },
      { Symbol: 'ADA', Name: 'Cardano', Price: 8.95, Change: -0.25, ChangePercent: -2.72, Volume: '89M' },
      { Symbol: 'SOL', Name: 'Solana', Price: 456.30, Change: 12.80, ChangePercent: 2.89, Volume: '234M' },
      { Symbol: 'DOGE', Name: 'Dogecoin', Price: 2.85, Change: 0.08, ChangePercent: 2.88, Volume: '67M' }
    ];
  }
}
